export const HIPPA_FORM_SUBMITTING = 'HIPPA_FORM_SUBMITTING' as const;
export const HIPPA_FORM_SUBMITTED = 'HIPPA_FORM_SUBMITTED' as const;
export const HIPPA_FORM_FAILED = 'HIPPA_FORM_FAILED' as const;
export const HIPPA_FORM_RESET = 'HIPPA_FORM_RESET' as const;
